import React from "react";
import { motion } from "framer-motion";
import { FaCloud, FaHeadset, FaBuilding } from "react-icons/fa";
import "./HostedVoice.css";

export default function HostedVoice(): JSX.Element {
  return (
    <motion.main
      className="page plans-page hosted-page"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
    >
      {/* HERO SECTION */}
      <section className="hero-banner hosted-hero">
        <h1>J-Voice Hosted (Small Office)</h1>
        <p>Streamline your business communications with a modern cloud-hosted PBX system.</p>
      </section>

      {/* ====== FLEX ROW: PLANS LEFT + DROPDOWN RIGHT ====== */}
      <div className="hosted-flex-row">

        {/* LEFT: PLAN CARDS */}
        <div className="hosted-plans">
          <section className="voice-comparison">

           

            {/* PAYG PLAN */}
            <div className="plan-column">
              <h3>PAYG</h3>
              <ul>
                <li className="section-title center">Hosted Voice Licence Includes</li>
                <li>Music on hold</li>
                <li>Auto attendant</li>
                <li>Call queuing</li>
                <li>Hunt groups</li>
                <li>Call recording (fees apply)</li>

                <li className="section-title center">Included Calls</li>
                <li>Local calls</li>
                <li>National calls</li>
                <li>Calls to mobiles</li>
                <li>13/1300 calls</li>
                <li>International calls</li>

                <li className="section-title center">Support</li>
                <li>Business-grade support</li>
                <li>Local Account Management</li>
              </ul>

              <div className="price-tag">$20</div>
              <span className="unit">/ licence / month</span>
              <a
                className="hosted-cis"
                href="/docs/Jortel%20Hosted%20Voice%20PAYG%20Critical%20Information%20Summary.pdf"
                target="_blank"
                rel="noopener noreferrer"
              >
                Critical Information Summary
              </a>
            </div>
 {/* PREMIUM PLAN */}
            <div className="plan-column popular">
              <h3>PREMIUM</h3>
              <ul>
                <li className="section-title center">Hosted Voice Licence Includes</li>
                <li>Music on hold</li>
                <li>Auto attendant</li>
                <li>Call queuing</li>
                <li>Hunt groups</li>
                <li>Call recording (fees apply)</li>

                <li className="section-title center">Included Calls</li>
                <li>Local calls</li>
                <li>National calls</li>
                <li>Calls to Australian mobiles</li>
                <li>13/1300 calls</li>
                <li>International calls</li>

                <li className="section-title center">Support</li>
                <li>Business-grade support</li>
                <li>Local Account Management</li>
              </ul>

              <div className="price-tag">$45</div>
              <span className="unit">/ licence / month</span>
              <a
                className="hosted-cis"
                href="/docs/Jortel%20Hosted%20Voice%20Critical%20Information%20Summary.pdf"
                target="_blank"
                rel="noopener noreferrer"
              >
                Critical Information Summary
              </a>
            </div>
          </section>
        </div>

        {/* RIGHT: ACCORDION DROPDOWNS */}
        <div className="hosted-dropdowns">
          <section className="charges-accordion">

            {/* FEATURES */}
            <div className="bf-accordion-item">
              <div
                className="bf-accordion-header"
                onClick={(e) => e.currentTarget.parentElement?.classList.toggle("open")}
              >
                <span>Hosted Voice Features</span>
                <span className="chevron">{">"}</span>
              </div>

              <div className="bf-accordion-body">
                <ul className="bf-feature-list">
                  <li>Automated attendant / IVR</li>
                  <li>Presence (BLF)</li>
                  <li>Hunt groups</li>
                  <li>Agent groups (Call Queuing)</li>
                  <li>Simultaneous ringing</li>
                  <li>Call diversion</li>
                  <li>Voicemail to email</li>
                  <li>Simple call recording</li>
                  <li>Music on hold</li>
                  <li>Group park</li>
                </ul>
              </div>
            </div>

            {/* ADD-ONS */}
            <div className="bf-accordion-item">
              <div
                className="bf-accordion-header"
                onClick={(e) => e.currentTarget.parentElement?.classList.toggle("open")}
              >
                <span>Add-ons & Extras</span>
                <span className="chevron">{">"}</span>
              </div>

              <div className="bf-accordion-body">
                <div className="bf-table bf-table-small">
                  <table>
                    <thead>
                      <tr>
                        <th>Service</th>
                        <th>Unit Type</th>
                        <th>Price</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr><td>Fax2Email (Inbound Only)</td><td>Monthly per Licence</td><td>$10.00</td></tr>
                      <tr><td>Premium UC Bolt-On (Mobile + Desktop)</td><td>Monthly</td><td>$10.00</td></tr>
                      <tr><td>Voice Recording</td><td>Monthly per Licence</td><td>$10.00</td></tr>
                      <tr><td>Custom Music / On Hold Message</td><td>Monthly</td><td>$40.00</td></tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            {/* SIP TRUNK PAYG */}
            <div className="bf-accordion-item">
              <div
                className="bf-accordion-header"
                onClick={(e) => e.currentTarget.parentElement?.classList.toggle("open")}
              >
                <span>SIP Trunk - PAYG Timed</span>
                <span className="chevron">{">"}</span>
              </div>

              <div className="bf-accordion-body">
                <div className="bf-table bf-table-small">
                  <table>
                    <thead>
                      <tr>
                        <th>Call Type</th>
                        <th>Unit</th>
                        <th>Price</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr><td>Local</td><td>Per Minute</td><td>$0.0220</td></tr>
                      <tr><td>National</td><td>Per Minute</td><td>$0.0220</td></tr>
                      <tr><td>13/1300</td><td>Per Call</td><td>$0.6000</td></tr>
                      <tr><td>Mobiles</td><td>Per Minute</td><td>$0.4500</td></tr>
                      <tr><td>1800</td><td>Per Call</td><td>$0.0000</td></tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            {/* OTHER CHARGES */}
            <div className="bf-accordion-item">
              <div
                className="bf-accordion-header"
                onClick={(e) => e.currentTarget.parentElement?.classList.toggle("open")}
              >
                <span>Other Charges</span>
                <span className="chevron">{">"}</span>
              </div>

              <div className="bf-accordion-body">
                <div className="bf-table bf-table-small">
                  <table>
                    <thead>
                      <tr>
                        <th>Service</th>
                        <th>Unit</th>
                        <th>Price</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr><td>1 GEO DID</td><td>Per Single</td><td>$5.00</td></tr>
                      <tr><td>10 GEO DID</td><td>Per 10 Block</td><td>$25.00</td></tr>
                      <tr><td>100 GEO DID</td><td>Per 100 Block</td><td>$50.00</td></tr>
                      <tr><td>Hosted Voice Activation Fee</td><td>Per Account</td><td>$99.00</td></tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            {/* NOTES */}
            <div className="bf-accordion-item">
              <div
                className="bf-accordion-header"
                onClick={(e) => e.currentTarget.parentElement?.classList.toggle("open")}
              >
                <span>Notes</span>
                <span className="chevron">{">"}</span>
              </div>

              <div className="bf-accordion-body">
                <div className="bf-box">
                  <ul>
                    <li>All pricing includes GST.</li>
                    <li>Timed calls billed per second increments.</li>
                    <li>Hosted Voice model applied globally (PAYG or Premium).</li>
                    <li>Month-to-month contract terms available.</li>
                    <li>UC Bolt-ons charged monthly per extension.</li>
                    <li>Fair Use Policy applies.</li>
                  </ul>
                </div>
              </div>
            </div>

          </section>
        </div>

      </div>
      {/* ====== END FLEX ROW ====== */}

      {/* WHY CHOOSE JORTEL */}
      <section className="advantages-section">
        <h2>Why choose Jortel for Hosted Voice?</h2>
        <div className="advantages-grid">
          <div className="adv-card">
            <FaCloud className="benefit-icon" />
            <h3>Cloud-first</h3>
            <p>Provision quickly without on-prem PBX hardware or complex installs.</p>
          </div>
          <div className="adv-card">
            <FaHeadset className="benefit-icon" />
            <h3>Built-in support</h3>
            <p>Local team, zero-touch provisioning, and fast changes when you need them.</p>
          </div>
          <div className="adv-card">
            <FaBuilding className="benefit-icon" />
            <h3>Scales with you</h3>
            <p>Per-user pricing, visual call flows, and features that grow with your offices.</p>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="advisor-panel">
        <div className="advisor-content">
          <h2>Need a Custom Setup?</h2>
          <p>Our solutions team can tailor a hosted voice package for your office.</p>
          <a href="/contact" className="btn primary">Talk to an Expert</a>
        </div>
      </section>

    </motion.main>
  );
}


